module.exports = __webpack_public_path__ + "img/166.0ac64455.png";